import { AlertsTabs, NarrowContainer, NewHeader } from "./components";
import { DurationContextProvider } from "./contexts/DurationContext";

export const Alerts = () => {
    return (
        <DurationContextProvider>
            <NarrowContainer>
                <NewHeader />
                <AlertsTabs />
            </NarrowContainer>
        </DurationContextProvider>
    );
};
